import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import clock from "../../../../assets/images/meetupEvent/clock.png";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import axios from "axios";
import "./SuperStarContent.css";
import { Markup } from "interweave";
import moment from "moment";
import Nav from "../../../../Layouts/Partial/PromoStarNav";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import ReactPlayer from "react-player";

const PendingVideoDetails = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState([]);

  useEffect(() => {
    const event_id = props.match.params.id;

    axios.get(`/api/star/promoVideo/pending/${event_id}`).then((res) => {
      {
        if (res.data.status == 200) {
          setEvent(res.data.promoVideos);
        }
      }
    });
  }, [props.match.params.id, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/promoVideo/approved/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/live/promoVideo");
        }
      });
    });
  };

  const decline = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/promoVideo/decline/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/live/promoVideo");
        }
      });
    });
  };

  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <div className="card event-card">
                <center>
                  <ReactPlayer
                    url={event.video_url ? videoCdnUrl + event.video_url : null}
                    autoplay
                    controls="true"
                    width={200}
                  />
                </center>
              </div>
            </div>
          </div>

          <div className="row my-4">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light p-2">{event.title}</h5>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3">
            {event.star_approval !== 0 ? (
              <>
                <button className="btn btnCreate fw-bold" onClick={handleClick}>
                  Approved
                </button>

                <button
                  className="btn btn-danger fw-bold mx-3"
                  onClick={decline}
                >
                  Decline
                </button>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingVideoDetails;
